import { createUseStyles } from 'react-jss';

const styles = {
  illustratedMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100vh'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'UnableLoadUserInfoPage'
});
